export default class OfferConnectionsItem {
  constructor($scope, OfferService) {
    $scope.get_status_css_class = function(offer) {
      if (offer.is_deleted)
        return 'red';
      else if (offer.is_visible && offer.is_active)
        return 'green';
      else if (!offer.is_visible && offer.is_active)
        return 'orange';
      else
        return '';
    };

    $scope.update_stocklist = function(offer) {
      offer.updating = true;
      OfferService.update_stocklist_from_parent(offer.id).then(function(data) {
        if (data.success) {
          offer.updating = false;
          $scope.load_offers();
        }
      });
    };
  }
}

OfferConnectionsItem.$inject = ['$scope', 'OfferService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-connections-item.ctrl.js